/* import useDBO from "../../hooks/useDBO.ts";
import Loading from "../../components/Loading.jsx";
import Error from "../../components/Error.jsx";
import { $type } from "./types.ts" */

import { useState } from "react";
import Select, { OptionType } from "../../components/Select.tsx";
import StudentInfo from "./components/StudentInfo.tsx";
import VideoLinks from "./components/VideoLinks.tsx";
import ScoreKey from "./components/ScoreKey.tsx";
import LessonScores from "./components/LessonScores.tsx";
import PersonalQualities from "./components/PersonalQualities.tsx";

type CourseCompleted = {
    lessons: number,
    totalLessons: number
}

export type Student = {
  name: string;
  class: string;
  teacher: string;
  syllabus: string;
  unit: number;
    courseCompleted: CourseCompleted;
  video: string,
};

type HtClassWithSyllabus = {
  name: string,
  _id: string,
  syllabus: { _id: string, name: string, numberOfLessons: number },
  teacher: {_id: string, name: string}
}

export default function UnitReport() {

  const [htClass, setHtClass] = useState("")
  const [st, setSt] = useState("")
  const [student,setStudent] = useState({
      name: "",
      class: "",
      teacher: "",
      syllabus: "",
      unit: 3,
      courseCompleted: { lessons: 60, totalLessons: 80 },
      video: "https://youtube.com"
    })



    const background = "#46bdc6";
    const bg = "#d1f6f9";
    const color = "#26428b";

  return (
    <div>
      <div className="flex gap-3">
        <Select
          value={htClass}
          setValue={setHtClass}
          options="/classes-with-syllabus"
          update={(opt: HtClassWithSyllabus) => {
            console.log(opt);
            setStudent((prev) => ({
              ...prev,
              student:"",
              class: opt.name,
              syllabus: opt.syllabus.name,
              courseCompleted: {
                lessons: 60,
                totalLessons: opt.syllabus.numberOfLessons,
              },
              teacher: opt.teacher.name,
            }));
          }}
          label="Class"
          width={300}
        />
        {htClass && (
          <Select
            value={st}
            setValue={setSt}
            options={`/students-in-class/${htClass}`}
            update={(opt: OptionType) =>
              setStudent((prev) => ({ ...prev, name: opt.name }))
            }
            width={300}
            label="Student"
          />
        )}
      </div>

      <div
        style={{ fontFamily: "lexend" }}
        className="flex flex-col gap-10"
      >
         <img src="../report.png" alt="Report" />
        <StudentInfo
          student={student}
          background={background}
          bg={bg}
          color={color}
        />
        <VideoLinks
          student={student}
          background={background}
          bg={bg}
          color={color}
        />
        <ScoreKey
          background={background}
          bg={bg}
          color={color}
        />
        <LessonScores
          scores={lessonScores}
          background={background}
          bg={bg}
          color={color}
        />
        <PersonalQualities
          scores={personalQualities}
          background={background}
          bg={bg}
          color={color}
        />
      </div>
    </div>
  );
}

const lessonScores = [
  { lesson: 1, score: 8 },
  { lesson: 2, score: 7 },
  { lesson: 3, score: 9 },
  { lesson: 4, score: 6 },
  { lesson: 5, score: 10 },
  { lesson: 6, score: 7 },
  { lesson: 7, score: 8 },
  { lesson: 8, score: 4 },
  { lesson: 9, score: 9 },
  { lesson: 10, score: 7 },
];

const personalQualities = [
  { label: "Mức độ chuyên cần", score: 8 },
  { label: "Ý thức học tập", score: 7 },
  { label: "Ý thức hoàn thành bài tập về nhà ", score: 9 },
];
